import client from "@/api";

export const getMemState = async (scope) => {
  const MEM_STATE_ENDPOINT = "/mem-state";

  const searchParameters = new URLSearchParams();
  searchParameters.append("scope", scope);

  const url = scope ? `${MEM_STATE_ENDPOINT}?${searchParameters.toString()}` : MEM_STATE_ENDPOINT;

  return await client.get(url);
};

export const clearMemState = async (scope) => {
  const MEM_STATE_ENDPOINT = "/mem-state";

  const searchParameters = new URLSearchParams();
  searchParameters.append("scope", scope);

  return await client.get(`${MEM_STATE_ENDPOINT}/clean?${searchParameters.toString()}`);
};
